/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 03/26/2017
 * Time: 7:21 PM
 */

var playSound = {
    playFail: function () {
        (function ($) {
            $('body').append('<audio id="background_audio" autoplay="autoplay">\n\
                <source src="/public/media/Check_in_FAIL.ogg" type="audio/ogg" />\n\
                </audio>\n\
                <bgsound id="background_snd" src="/public/media/Check_in_FAIL.ogg" autostart="true" loop="0">');
        })(jQuery);
    }
};

export default playSound;
